import React from 'react';
import { NavLink } from 'react-router-dom';

import useFeatureAccesses from '~/src/hooks/useFeatureAccesses';
import {
  useCurrentOrg,
  useCustomXmlTemplateFormatEnabled,
  useDraftingAgentEnabled,
} from '~/src/entities/user';
import ClioTemplatesSection from './ClioTemplatesSection';
import FirmTemplatesSection from './FirmTemplatesSection';
import { CUSTOM_TEMPLATES_STRING } from './constants';
import { useCheckClioTemplatesExist } from '~/src/entities/template/hooks/useCheckClioTemplatesExist';

const renderPaidSection = (wordAddInDownloadUrl, addInLabel) => (
  <div className="text-center mt-2">
    You can create a new template using the{' '}
    <a href={wordAddInDownloadUrl} target="_blank" rel="noreferrer">
      {addInLabel}
    </a>
  </div>
);

const renderNonPaidSection = () => (
  <div className="text-center mt-3">
    <NavLink to={'/settings/subscriptions'}>Upgrade now</NavLink>
  </div>
);

const TemplatesEmptyView = () => {
  const {
    isWordDocumentAutomationEnabled,
    isPracticeAreaStandardContentEnabled,
  } = useFeatureAccesses();
  const { org } = useCurrentOrg();
  const draftingAgentEnabled = useDraftingAgentEnabled();
  const { data: clioTemplatesExist } = useCheckClioTemplatesExist();
  const isCustomXmlOrg = useCustomXmlTemplateFormatEnabled();
  const wordAddInDownloadUrl = isCustomXmlOrg
    ? 'https://marketplace.microsoft.com/en-us/product/office/WA200010602?tab=Overview'
    : 'https://appsource.microsoft.com/en-us/product/office/WA200008525?tab=Overview';
  const wordAddInLabel = isCustomXmlOrg
    ? 'Clio for Word add-in found here.'
    : 'Clio Draft Word add-in found here.';

  const primaryPracticeArea = org?.primary_practice_area;
  const secondaryPracticeArea = org?.secondary_practice_area;
  const primaryState = org?.primary_state;

  const NoTemplatesDraftingAgentDisabledSection = () => (
    <div className="bg-white border border-gray-200 rounded-lg p-6 pb-10">
      <h3 className="text-lg font-semibold mb-4">{CUSTOM_TEMPLATES_STRING}</h3>
      <div className="text-center mt-12 text-lg font-medium">
        Automate your Word documents
      </div>
      <div className="text-center mt-2">
        Turn your custom Word documents into fillable cloud-based templates.
      </div>
      {isWordDocumentAutomationEnabled &&
        renderPaidSection(wordAddInDownloadUrl, wordAddInLabel)}
      {!isWordDocumentAutomationEnabled && renderNonPaidSection()}
    </div>
  );

  return (
    <div className="mx-auto" style={{ width: '100%', maxWidth: '1080px' }}>
      {isPracticeAreaStandardContentEnabled && clioTemplatesExist && (
        <ClioTemplatesSection
          primaryPracticeArea={primaryPracticeArea}
          secondaryPracticeArea={secondaryPracticeArea}
          primaryState={primaryState}
        />
      )}
      {draftingAgentEnabled && isPracticeAreaStandardContentEnabled ? (
        <FirmTemplatesSection />
      ) : (
        <NoTemplatesDraftingAgentDisabledSection />
      )}
    </div>
  );
};

export default TemplatesEmptyView;
